import { useFormContext, FieldErrors, Controller } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

export const EnterpriseContactForm = () => {
  const { register, formState: { errors }, control } = useFormContext<{
    contactPerson: {
      name?: string;
      email?: string;
      phone?: string;
    };
    location: {
      address?: string;
      city?: string;
      country?: string;
    };
  }>();

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="contactPerson.name">Contact Person Name <span className="text-red-600">*</span></Label>
        <Input
          id="contactPerson.name"
          placeholder="e.g., John Doe"
          {...register("contactPerson.name")}
          className="border-blue-100 focus:border-emerald-300 focus:ring-1 focus:ring-emerald-300"
        />
        {errors.contactPerson?.name && (
          <p className="text-xs text-red-500">{errors.contactPerson.name.message}</p>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor="contactPerson.email">Contact Email <span className="text-red-600">*</span></Label>
        <Input
          id="contactPerson.email"
          type="email"
          placeholder="you@example.com"
          {...register("contactPerson.email")}
          className="border-blue-100 focus:border-emerald-300 focus:ring-1 focus:ring-emerald-300"
        />
        {errors.contactPerson?.email && (
          <p className="text-xs text-red-500">{errors.contactPerson.email.message}</p>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor="contactPerson.phone">Contact Phone <span className="text-red-600">*</span></Label>
        <Controller
          name="contactPerson.phone"
          control={control}
          render={({ field }) => (
            <PhoneInput
              {...field}
              international
              defaultCountry="US"
              placeholder="Enter phone number"
              className="border-blue-100 focus:border-emerald-300 focus:ring-1 focus:ring-emerald-300 rounded-md border p-2 w-full [&_input]:bg-transparent"
            />
          )}
        />
        {errors.contactPerson?.phone?.message && (
          <p className="text-xs text-red-500">{errors.contactPerson.phone.message as string}</p>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor="location.address">Address <span className="text-red-600">*</span></Label>
        <Input
          id="location.address"
          {...register("location.address")}
          placeholder="e.g., 123 Main St, Apt 4B"
          className="border-blue-100 focus:border-emerald-300 focus:ring-1 focus:ring-emerald-300"
        />
        {errors.location?.address && (
          <p className="text-xs text-red-500">{errors.location.address.message}</p>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor="location.city">City <span className="text-red-600">*</span></Label>
        <Input
          id="location.city"
          placeholder="e.g., New York"
          {...register("location.city")}
          className="border-blue-100 focus:border-emerald-300 focus:ring-1 focus:ring-emerald-300"
        />
        {errors.location?.city && (
          <p className="text-xs text-red-500">{errors.location.city.message}</p>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor="location.country">Country <span className="text-red-600">*</span></Label>
        <Input
          id="location.country"
          placeholder="e.g., USA"
          {...register("location.country")}
          className="border-blue-100 focus:border-emerald-300 focus:ring-1 focus:ring-emerald-300"
        />
        {errors.location?.country && (
          <p className="text-xs text-red-500">{errors.location.country.message}</p>
        )}
      </div>
    </div>
  );
};